import React from 'react';
import MediaQuery from 'react-responsive';
import CraftBeer from 'components/organisms/craftBeerAndBrewery';
import CraftBeerSectionMobile from 'components/organisms/craftBeerAndBreweryMobile';

const CraftBeerSection = props => {
  return (
    <div id={'brewery'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <CraftBeerSectionMobile data={props.data} />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <CraftBeer data={props.data} />
      </MediaQuery>
    </div>
  );
};

export default CraftBeerSection;
